import React from 'react'
import _ from 'underscore'
import { BookOpen, ExternalLink, GraduationCap, SlidersHorizontal, User } from 'lucide-react'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import DebouncedInput from '../../../debounced_input'
import ToggleOptions from '../../../toggle_options'
import LeadSubjects from './subjects/index'
import Address from '../../../address/show'
import DatePickerInput from '../../../date_picker_input'

class LeadDetails extends React.Component {

  onChallengeChange = (value) => {
    this.props.store.emit('lead:settings:update', this.props.lead.id, {challenge: value})
  }

  onBudgetChange = (value) => {
    this.props.store.emit('lead:settings:update', this.props.lead.id, {budget: value})
  }

  onNameChange = (value) => {
    this.props.store.emit('lead:settings:update', this.props.lead.id, {enquirer_name: value})
  }

  onEmailAddressChange = (value) => {
    this.props.store.emit('lead:settings:update', this.props.lead.id, {enquirer_email_address: value})
  }

  onContactNumberChange = (value) => {
    this.props.store.emit('lead:settings:update', this.props.lead.id, {enquirer_contact_number: value})
  }

  onLearnerNameChange = (value) => {
    this.props.store.emit('lead:settings:update', this.props.lead.id, {learner_name: value})
  }

  onLearnerTypeChange = (value) => {
    this.props.store.emit('lead:settings:update', this.props.lead.id, {learner_type: value})
  }

  onLearnerGenderChange = (value) => {
    this.props.store.emit('lead:settings:update', this.props.lead.id, {learner_gender: value})
  }

  onSubjectCategoryChange = (value) => {
    const subjects = _.map(this.props.lead.settings.subjects, function(subject) {
      return (
        {
          name: subject.name,
          subject_category_name: value,
          subject_level_name: subject.subject_level_name,
          syllabus: subject.syllabus,
          known: subject.known
        }
      )
    })

    this.props.store.emit('lead:settings:update', this.props.lead.id, {
      subject_category_name: value,
      subject_level_name: '',
      subjects: subjects
    })
  }

  onSubjectLevelChange = (value) => {
    const subjects = _.map(this.props.lead.settings.subjects, function(subject) {
      return (
        {
          name: subject.name,
          subject_category_name: subject.subject_category_name,
          subject_level_name: value,
          syllabus: subject.syllabus,
          known: subject.known
        }
      )
    })

    this.props.store.emit('lead:settings:update', this.props.lead.id, {
      subject_level_name: value,
      subjects: subjects
    })
  }

  onLessonDurationChange = (value) => {
    this.props.store.emit('lead:settings:update', this.props.lead.id, {lesson_duration: value})
  }

  onStartDateChange = (value) => {
    this.props.store.emit('lead:settings:update', this.props.lead.id, {start_date: value})
  }

  onLanguageChange = (value) => {
    this.props.store.emit('lead:settings:update', this.props.lead.id, {language_id: value})
  }

  onTutorGenderChange = (value) => {
    this.props.store.emit('lead:settings:update', this.props.lead.id, {tutor_gender: value})
  }

  onCommitmentChange = (value) => {
    this.props.store.emit('lead:settings:update', this.props.lead.id, {commitment: value})
  }

  onUrgencyChange = (value) => {
    this.props.store.emit('lead:settings:update', this.props.lead.id, {urgency: value})
  }

  onLessonMediumChange = (value) => {
    this.props.store.emit('lead:settings:update', this.props.lead.id, {lesson_medium: value})
  }

  extractAddressField(address_components, field) {
    const record = _.first(
      _.select(address_components, function(x) {
        return x.types.includes(field)
      })
    )
    
    return (record || {}).long_name || ''
  }

  extractAddressFields(address_components) {
    const street_number = this.extractAddressField(address_components, 'street_number')
    const street = this.extractAddressField(address_components, 'route')
    const suburb = this.extractAddressField(address_components, 'sublocality')
    const city = this.extractAddressField(address_components, 'locality')
    const region = this.extractAddressField(address_components, 'administrative_area_level_1')
    const country = this.extractAddressField(address_components, 'country')
    const postal_code = this.extractAddressField(address_components, 'postal_code')

    return {
      street_number: street_number,
      street: street,
      suburb: suburb,
      city: city,
      region: region,
      country: country,
      postal_code: postal_code
    }
  }

  onAddressChange = (params = {}) => {
    this.props.store.emit('lead:settings:update', this.props.lead.id, {
      flat_unit_estate: params.flat_unit_estate,
      address_note: params.note,
      formatted_address: params.formatted_address,
      address_components: params.address_components,
      latitude: params.latitude,
      longitude: params.longitude
    })
  }

  onSaveAvailability = () => {
    this.props.store.emit('lead:settings:update', this.props.lead.id, {availability: this.props.lead.settings.availability})
  }
  
  render() {
    const lead = this.props.lead
    const settings = lead.settings

    const address = {
      latitude: settings.latitude || -30.86451,
      longitude: settings.longitude || 24.23584,
      note: settings.address_note,
      flat_unit_estate: settings.flat_unit_estate
    }

    const markers = [
      {
        latitude: settings.latitude,
        longitude: settings.longitude,
        content: settings.formatted_address,
        open: settings.latitude && settings.longitude
      }
    ]

    const learnerTypeOptions = [
      {value: 'daughter', name: 'Daughter'},
      {value: 'son', name: 'Son'},
      {value: 'myself', name: 'Me'},
      {value: 'someone_else', name: 'Someone else'},
    ]

    const learnerGenderOptions = [
      {value: 'male', name: 'Male'},
      {value: 'female', name: 'Female'}
    ]

    const subjectCategoryOptions = _.map(lead.meta.options.subject_categories, (subject_category) => {
      return {value: subject_category.name, name: subject_category.name}
    })

    const subjectLevelOptions = _.map(lead.meta.options.subject_levels, (subject_level) => {
      return {value: subject_level.name, name: subject_level.name}
    })

    const lessonDurationOptions = [
      {value: '45', name: '45 minutes'},
      {value: '60', name: '1 hour'},
      {value: '90', name: '1.5 hours'},
      {value: '120', name: '2 hours'},
      {value: 'please_advise_me', name: 'Please advise me'}
    ]

    const languageOptions = _.map(lead.languages, function(language) {
      return {
        name: language.name,
        value: language.id
      }
    })

    const tutorGenderOptions = [
      {value: 'any', name: 'Any'},
      {value: 'female', name: 'Female'},
      {value: 'male', name: 'Male'}
    ]
    
    const commitmentOptions = [
      {value: '1_to_3_months', name: '1 – 3 months'},
      {value: '3_to_6_months', name: '3 – 6 months'},
      {value: 'six_plus_months', name: '6+ months'},
      {value: 'please_advise_me', name: 'Advise me'}
    ]

    const urgencyOptions = [
      {value: 'asap', name: 'ASAP'},
      {value: 'this_week', name: 'This week'},
      {value: 'this_month', name: 'This month'},
      {value: 'later', name: 'Later'}
    ]

    const lessonMediumOptions = [
      {value: 'local', name: 'Face-to-face'},
      {value: 'online', name: 'Online'}
    ]

    const challengeOptions = [
      {value: 'fundamental_gaps', name: 'Fundamental gaps in understanding'},
      {value: 'problem_areas', name: 'A few specific problem areas'},
      {value: 'immediate_help', name: 'Immediate help for an exam/test'}
    ]

    const requested_tutor = lead.requested_tutor

    return (
      <div className="grid grid-cols-1 items-start gap-4 md:grid-cols-2">
        <div className="flex flex-col gap-4">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <User className="size-4" />
                Enquirer
              </CardTitle>
            </CardHeader>
            <CardContent className="grid gap-6">
              <div className="grid gap-2">
                <Label>Name</Label>
                <DebouncedInput value={settings.enquirer_name || ''} placeholder="Name" onChange={this.onNameChange}/>
              </div>
              <div className="grid gap-2">
                <Label>Email Address</Label>
                <DebouncedInput value={settings.enquirer_email_address || ''} placeholder="Email Address" onChange={this.onEmailAddressChange}/>
              </div>
              <div className="grid gap-2">
                <Label>Contact Number</Label>
                <DebouncedInput value={settings.enquirer_contact_number || ''} placeholder="Contact Number" onChange={this.onContactNumberChange}/>
              </div>
              {requested_tutor ?
                <div className="grid gap-2">
                  <Label>Requested Tutor</Label>
                  <a href={requested_tutor.link} target="_blank" className="text-sm text-primary no-underline hover:underline">
                    {requested_tutor.name} <ExternalLink className="ml-0.5 inline size-3"/>
                  </a>
                </div>
                : null
              }
              <div className="grid gap-2">
                <Label>Budget</Label>
                <ToggleOptions options={lead.budget_options} pressed={settings.budget} onClick={this.onBudgetChange} />
              </div>
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <GraduationCap className="size-4" />
                Learner
              </CardTitle>
            </CardHeader>
            <CardContent className="grid gap-6">
              <div className="grid gap-2">
                <Label>Learner Name</Label>
                <DebouncedInput value={settings.learner_name || ''} placeholder="Learner Name" onChange={this.onLearnerNameChange}/>
              </div>
              <div className="grid gap-2">
                <Label>Learner Type</Label>
                <ToggleOptions options={learnerTypeOptions} pressed={settings.learner_type} onClick={this.onLearnerTypeChange} />
              </div>
              <div className="grid gap-2">
                <Label>Learner Gender</Label>
                <ToggleOptions options={learnerGenderOptions} pressed={settings.learner_gender} onClick={this.onLearnerGenderChange} />
              </div>
            </CardContent>
          </Card>
          <Address
            key={lead.id}
            address={address}
            loaded={this.props.ui.google_map.loaded}
            markers={markers}
            formatted_address={settings.formatted_address}
            flat_unit_estate={settings.flat_unit_estate}
            onChange={this.onAddressChange}
            store={this.props.store}
          />
        </div>
        <div className="flex flex-col gap-4">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <BookOpen className="size-4" />
                Lessons
              </CardTitle>
            </CardHeader>
            <CardContent className="grid gap-6">
              <div className="grid gap-2">
                <Label>Subject Category</Label>
                <ToggleOptions options={subjectCategoryOptions} pressed={settings.subject_category_name} onClick={this.onSubjectCategoryChange} />
              </div>
              <div className="grid gap-2">
                <Label>Subject Level</Label>
                <ToggleOptions
                  options={subjectLevelOptions}
                  pressed={settings.subject_level_name}
                  onClick={this.onSubjectLevelChange}
                />
              </div>
              <div className="grid gap-2">
                <Label>Subjects</Label>
                <LeadSubjects
                  subjects={settings.subjects || []}
                  lead={lead}
                  store={this.props.store}
                />
              </div>
              <div className="grid gap-2">
                <Label>Lesson Medium</Label>
                <ToggleOptions options={lessonMediumOptions} pressed={settings.lesson_medium} onClick={this.onLessonMediumChange} />
              </div>
              <div className="grid gap-2">
                <Label>Urgency</Label>
                <ToggleOptions options={urgencyOptions} pressed={settings.urgency} onClick={this.onUrgencyChange} />
              </div>
              <div className="grid gap-2">
                <Label>Customer Note</Label>
                <Textarea rows="8" value={settings.additional_notes || ''} disabled/>
              </div>
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <SlidersHorizontal className="size-4" />
                Other
              </CardTitle>
            </CardHeader>
            <CardContent className="grid gap-6">
              <div className="grid gap-2">
                <Label>Challenge</Label>
                <ToggleOptions options={challengeOptions} pressed={settings.challenge} onClick={this.onChallengeChange} />
              </div>
              <div className="grid gap-2">
                <Label>Lesson Duration</Label>
                <ToggleOptions options={lessonDurationOptions} pressed={settings.lesson_duration} onClick={this.onLessonDurationChange} />
              </div>
              <div className="grid gap-2">
                <Label>Start Date</Label>
                <DatePickerInput value={settings.start_date || ''} placeholder="Start date" onChange={this.onStartDateChange}/>
              </div>
              <div className="grid gap-2">
                <Label>Language</Label>
                <ToggleOptions options={languageOptions} pressed={settings.language_id} onClick={this.onLanguageChange} />
              </div>
              <div className="grid gap-2">
                <Label>Tutor Gender</Label>
                <ToggleOptions options={tutorGenderOptions} pressed={settings.tutor_gender} onClick={this.onTutorGenderChange} />
              </div>
              <div className="grid gap-2">
                <Label>Commitment</Label>
                <ToggleOptions options={commitmentOptions} pressed={settings.commitment} onClick={this.onCommitmentChange} />
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    )
  }
}

export default LeadDetails